import { useContext } from "react"
import { SwitchContext } from "lib/@components/switch"

export function CaseElse({ children, then }) {
    const { cases } = useContext(SwitchContext)
    if (!Object.values(cases).some((v) => !!v)) {
        return <>{then || children}</>
    }
    return null
}
